import { useEffect, useState, useRef } from "react";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import {
  CLEAR_BASKET_URL,
  GET_CONFIRMATION,
  GET_CONFIRMATION_DOCUMENT,
  GET_CONFIRMATION_TICKETS,
} from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import { ConfirmationData } from "../../models/ConfirmationData";
import convertToPdf from "../../../utils/convertToPdf";
import { post } from "../../api";
import { useLocation } from "react-router";
import qs from "qs";
import { sendPurchaseEvent, convertConfirmationDataToGtmFormat } from "../../../utils/Analitics/GtmEvents";
import ReactPixel from "react-facebook-pixel";
import { canSendToFacebookPixel } from "../../../utils/Analitics/analiticsConfigByFacility";

export default function useConfirmationData() {
  const { get } = useApiRequest();
  const location = useLocation();
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [billKey, setBillKey] = useState("");
  const purchaseEventSentRef = useRef(false);
  const [confirmationData, setConfirmationData] = useState({
    docNumber: "",
    name: "",
    lastName: "",
    email: "",
    phone: "",
    containsInvoice: false,
    containsTickets: false,
    billIds: "",
    discountCode: "",
    discountValue: 0,
    lines: [],
    payName: "",
    total: "",
    transactionId: "",
  } as ConfirmationData);

  const handleClearBasket = async () => {
    await post(CLEAR_BASKET_URL(facilityIds));
  };

  useEffect(() => {
    handleClearBasket();
    const url_string = sessionStorage.getItem("parentPageUrl");
    if (url_string !== null) {
      var url = new URL(url_string);
      var k = url.searchParams.get("k");
      setBillKey(k as string);
    }
    if (url_string === null) {
      const billKeyParam = qs.parse(location.search.slice(1)).k as string;
      setBillKey(billKeyParam);
    }

    //eslint-disable-next-line
  }, []);

  const getConfirmationData = async () => {
    setLoading(true);
    const params = {
      facilityIds: `0,${facilityIds}`,
      billKey: billKey,
    };
    const { result, isError } = await get(GET_CONFIRMATION(params));
    if (!isError) {
      setConfirmationData(result);

      // Wysyłanie purchase event do GTM i Pixel po pobraniu danych potwierdzenia - tylko raz!
      if (!purchaseEventSentRef.current) {
        try {
          const purchaseData = convertConfirmationDataToGtmFormat(result);
          sendPurchaseEvent(facilityIds, purchaseData);

          if (canSendToFacebookPixel(facilityIds)) {
            ReactPixel.track("Purchase", {
              value: purchaseData.value,
              currency: "PLN",
              content_ids: purchaseData.items.map((item) => item.item_id),
              contents: purchaseData.items.map((item) => ({
                id: item.item_id,
                quantity: item.quantity,
              })),
              num_items: purchaseData.items.length,
            });
          }

          purchaseEventSentRef.current = true;
        } catch (error) {
          console.error("Error sending analytics purchase event:", error);
        }
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getConfirmationData();
    //eslint-disable-next-line
  }, [billKey, facilityIds]);

  const getConfirmationDocument = async () => {
    setLoading(true);
    const params = {
      facilityIds: `0,${facilityIds}`,
      billKey: billKey,
    };
    const { result, isError } = await get(GET_CONFIRMATION_DOCUMENT(params));
    if (!isError) {
      const pdf = convertToPdf(result);
      window.open(URL.createObjectURL(pdf));
    }
    setLoading(false);
  };

  const getConfirmationTickets = async () => {
    setLoading(true);
    const params = {
      facilityIds: `0,${facilityIds}`,
      billKey: billKey,
    };
    const { result, isError } = await get(GET_CONFIRMATION_TICKETS(params));
    if (!isError) {
      const pdf = convertToPdf(result);
      window.open(URL.createObjectURL(pdf));
    }
    setLoading(false);
  };

  return {
    billKey,
    loading,
    confirmationData,
    getConfirmationDocument,
    getConfirmationTickets,
    facilityIds,
  };
}
